<template>
  <el-container class="track-monitor">
    <el-aside width="200px" v-if="isCollapse">
      <div class="menu-title custom-title">
        <span class="prefix-icon"></span>
        <span>{{ $t('设备列表') }}</span>
      </div>
      <Menu @select="selectHandler" :default-active="sn" :list="menus" />
    </el-aside>
    <el-main>
      <div class="main-header">
        <div class="main-title custom-title">
          <span class="prefix-icon"></span>
          <span>{{ $t('走航图') }}</span>
        </div>
        <div class="toggle-icon" @click="changeCollapse">
          <em :class="!isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></em>
        </div>
      </div>
      <Bmap ref="map" @loaded="mapLoaded">
        <div class="map-control">
          <!-- <el-button @click="clickHandler">
            {{ isTracking === 1 ? '结束走航' : '开始走航' }}
          </el-button> -->
          <GradientBar v-if="sn" :max="max" :gradient="gradient" width="100px" unit="TVOC (ppm)" />
        </div>
      </Bmap>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import GradientBar from '@/components/gradientBar';

import { timer } from '@/utils/utils';
import BasicMixin from './mixins/basic';
import { closeWindowListener } from '@/utils/socket';
import { trackDevice, beginTrack, stopTrack, getTrackParam } from '@/api/track';

export default {
  mixins: [BasicMixin],
  components: { GradientBar },
  sockets: {
    '/socket/detail'(res) {
      if (!(res && this.sn && res.sn === this.sn)) return;
      const { longitude, latitude, mods, devicemapMap } = res;
      const count = mods && mods.tvocMod && mods.tvocMod.pidValue;
      const max = devicemapMap.max;

      if (!isNaN(count)) {
        this.map && this.map.addPoint(longitude, latitude, (count / max) * 100);
      }
      // if (max) {
      //   this.max = max;
      // }
    }
  },
  data() {
    return {
      map: null,
      isTracking: 0,
      sn: '',
      menus: [],
      removeListener: null,
      max: 10,
      gradient: {
        // 对应比例渐变色
        0: 'rgba(0,0,128,1)',
        0.125: 'rgba(0,4,255,1)',
        0.376: 'rgb(2,255,255)',
        0.62: 'rgba(254,255,1,1)',
        0.87: 'rgba(255,0,0,1)',
        '1.0': 'rgba(130,0,0,1)'
      }
    };
  },
  computed: {
    ...mapState('socket', ['deviceIdMap'])
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    mapLoaded(map) {
      this.map = map;
    },
    clickHandler() {
      if (!this.sn) return;
      if (this.isTracking === 1) {
        stopTrack(this.sn);
        this.isTracking = 0;
      } else {
        beginTrack(this.sn);
        this.isTracking = 1;
      }
    },
    async selectHandler({ id, nodeType }) {
      const { sn } = this.deviceIdMap[id] || {};
      if (sn) {
        this.sn = sn;
        this.initMapParams();
      }
      const { data } = (await trackDevice({ id, nodeType })) || {};
      // this.$socket.emit('/socket/detail', sn);
      this.subDeviceDetail({ sn: this.sn });
      if (!data) return;
      const { centerPosition, isTracking, max } = data;
      this.isTracking = +isTracking;
      this.max = max || 10;

      const clearAnimation = this.map.locateTo({ center: centerPosition, zoom: 18 });
      timer(() => clearAnimation(), 2000);
    },
    unsubscribe() {
      this.unsubDeviceDetail({ sn: this.sn });
      // this.$socket.emit('/socket/unsubscribe/detail', this.sn);
    },
    async initMapParams() {
      const res = await getTrackParam(this.sn);
      if (!res || !res.data || !res.data.deviceMapParamItems) return;
      const items = res.data.deviceMapParamItems;

      const params = {};
      items.forEach(e => {
        params[e.itemCode] = e.value;
      });
      if (params.gradient) {
        this.gradient = JSON.parse(params.gradient);
      }

      // if (params.max) {
      //   this.max = +(params.max || 10);
      // }
    }
  },
  created() {
    this.removeListener = closeWindowListener(() => this.unsubscribe());
  },
  beforeDestroy() {
    this.unsubscribe();
    this.removeListener && this.removeListener();
  }
};
</script>

<style lang="scss">
.track-monitor {
  height: 100%;
  .menu-title {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    color: #0ef;
  }
  .prefix-icon {
    display: inline-block;
    background-color: #f5ff54;
    height: 10px;
    width: 4px;
    margin-right: 5px;
  }
  .custom-title {
    font-size: 20px;
    font-weight: bold;
  }

  .el-main {
    height: 100%;
    overflow: hidden;
    padding-left: 20px;
  }

  .main-header {
    display: flex;
    align-items: center;
    color: #0ef;

    .toggle-icon {
      width: 60px;
      text-align: center;
      font-size: 26px;
      cursor: pointer;
    }
  }

  .map-control {
    position: absolute;
    right: 15px;
    top: 20px;
    z-index: 10;
  }
}
</style>
